export const PROFILE_TAB_OVERVIEW_FETCH_REQUEST = 'PROFILE_TAB:OVERVIEW_FETCH_REQUEST';
export const PROFILE_TAB_OVERVIEW_FETCH_SUCCESS = 'PROFILE_TAB:OVERVIEW_FETCH_SUCCESS';
export const PROFILE_TAB_OVERVIEW_FETCH_FAILURE = 'PROFILE_TAB:OVERVIEW_FETCH_FAILURE';
export const PROFILE_TAB_RESULTS_FETCH_REQUEST = 'PROFILE_TAB:RESULTS_FETCH_REQUEST';
export const PROFILE_TAB_RESULTS_FETCH_SUCCESS = 'PROFILE_TAB:RESULTS_FETCH_SUCCESS';
export const PROFILE_TAB_RESULTS_FETCH_FAILURE = 'PROFILE_TAB:RESULTS_FETCH_FAILURE';
export const PROFILE_TAB_EVENTS_FETCH_REQUEST = 'PROFILE_TAB:EVENTS_FETCH_REQUEST';
export const PROFILE_TAB_EVENTS_FETCH_SUCCESS = 'PROFILE_TAB:EVENTS_FETCH_SUCCESS';
export const PROFILE_TAB_EVENTS_FETCH_FAILURE = 'PROFILE_TAB:EVENTS_FETCH_FAILURE';
export const PROFILE_TAB_CLUBS_FETCH_REQUEST = 'PROFILE_TAB:CLUBS_FETCH_REQUEST';
export const PROFILE_TAB_CLUBS_FETCH_SUCCESS = 'PROFILE_TAB:CLUBS_FETCH_SUCCESS';
export const PROFILE_TAB_CLUBS_FETCH_FAILURE = 'PROFILE_TAB:CLUBS_FETCH_FAILURE';
export const PROFILE_TAB_STATS_FETCH_REQUEST = 'PROFILE_TAB:STATS_FETCH_REQUEST';
export const PROFILE_TAB_STATS_FETCH_SUCCESS = 'PROFILE_TAB:STATS_FETCH_SUCCESS';
export const PROFILE_TAB_STATS_FETCH_FAILURE = 'PROFILE_TAB:STATS_FETCH_FAILURE';
export const PROFILE_TAB_CLEAR_ALL_DATA = 'PROFILE_TAB:CLEAR_ALL_DATA';
export const PROFILE_TAB_HAS_CHANGED_PROFILES = 'PROFILE_TAB:HAS_CHANGED_PROFILES';
